// extracted by mini-css-extract-plugin
module.exports = {"block":"e_5s","lead":"e_6s","faces":"e_7s","face":"e_8s","plus":"e_9s","copy":"e_-s","title":"e_at","text":"e_bt","button":"e_ct","buttonIcon":"e_dt"};